import { lazy } from "react";
import Loadable from "app/components/Loadable";

// Lazy load your OPD Consultation pages
const OPDConsultation = Loadable(
  lazy(() => import("./OPDConsultationWorkspace")),
);

const OPDRoutes = [
  {
    path: "/patients/visits/opd/:visitId",
    element: <OPDConsultation />,
  },
];

export default OPDRoutes;
